import Base from "./base";
import Medications from "./medications";
import Procedures from "./procedures";
import Users from "./users";

type ExtendedAutoComplete = typeof Base & {
  Medications: typeof Medications;
  Procedures: typeof Procedures;
  Users: typeof Users;
};

const AutoComplete = Base as ExtendedAutoComplete;

AutoComplete.Medications = Medications;
AutoComplete.Procedures = Procedures;
AutoComplete.Users = Users;

export default AutoComplete;
